(()=>{
  window.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.subpage-menu').forEach(el => {
      const subpageMenuSwiper = new Swiper(el.querySelector('.swiper'), {
        slidesPerView: 'auto',
        spaceBetween: 0,
        freeMode: true,
        navigation: {
          nextEl: el.querySelector('.__next'),
          prevEl: el.querySelector('.__prev'),
        },
      });

      el.querySelectorAll('.__item').forEach((item, index) => {
        if (item.classList.contains('--active')) {
          subpageMenuSwiper.slideTo(index, 0);
        }
      });

      window.addEventListener('scroll', () => {
        const subpageMenuRect = el.getBoundingClientRect();
        if (subpageMenuRect.top <= 1) {
          el.classList.add('--stickied');
          document.querySelector('#header').classList.add('--force-hide');
        } else {
          el.classList.remove('--stickied');
          document.querySelector('#header').classList.remove('--force-hide');
        }
      });
    });

    document.querySelectorAll('.search-results').forEach(el => {
      const tabMenuSwiper = new Swiper(el.querySelector('.__tabs .swiper'), {
        slidesPerView: 'auto',
        spaceBetween: 24,
        freeMode: true,
      });

    })


    document.querySelectorAll('[data-ellipsis]').forEach(el => {
      const lines = el.getAttribute('data-ellipsis');
      el.style.webkitLineClamp = lines;
    });


    const hash = window.location.hash;
    if (hash) {
      const id = hash.replace('#', '');
      const target = document.getElementById(id);
      if (target) {
        if (hash === '#tabmenu' ) {
          document.querySelector('#header').style.pointerEvents = 'none';
          document.querySelector('#header').style.display = 'none';
        }
        setTimeout(()=>{
          if (window.lenis) {
            window.lenis.scrollTo(target, {force:true, lock: true, offset:0, duration:0.2, onComplete:()=>{
                document.querySelector('#header').removeAttribute('style');
              }});
          } else {
            gsap.to(window, {scrollTo:{y:target, duration:0.2, onComplete:()=>{
                  document.querySelector('#header').removeAttribute('style');}
              }
            });
          }
        }, 200);
      }
    }
  });

})();